import type { ContentOperationsFragment$data } from './__generated__/ContentOperationsFragment.graphql.ts';
import { OperationTypes } from './operationsTypes.ts';

export type ContentOperations = ContentOperationsFragment$data['operations'];

/**
 * Whether the current user may add comments to the content these operations belong to.
 *
 * Typed against `ContentOperationsFragment` so the predicate follows the fragment if its selection
 * changes. Every caller reads the same `operations { operation targetType }` selection, whether they
 * spread the fragment into a dedicated permission query or into a larger page query.
 */
export const canAddCommentsFromOperations = (operations: ContentOperations | undefined): boolean =>
	operations?.some(
		(operation) =>
			operation?.operation === OperationTypes.CREATE && operation?.targetType === 'comment',
	) ?? false;
